var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as PIXI from "pixi.js";
import { MeshMixin } from "./meshMixin";
import { DeformerStack } from "./deformers/deformerStack";
var VERBOSE = false;
export var GRAPHIC_TYPE;
(function (GRAPHIC_TYPE) {
    GRAPHIC_TYPE[GRAPHIC_TYPE["BOUNDS"] = 0] = "BOUNDS";
    GRAPHIC_TYPE[GRAPHIC_TYPE["LINE"] = 1] = "LINE";
    GRAPHIC_TYPE[GRAPHIC_TYPE["WORD"] = 2] = "WORD";
    GRAPHIC_TYPE[GRAPHIC_TYPE["GLYPH"] = 3] = "GLYPH";
})(GRAPHIC_TYPE || (GRAPHIC_TYPE = {}));
var FontAtlasTextGraphic = /** @class */ (function (_super) {
    __extends(FontAtlasTextGraphic, _super);
    function FontAtlasTextGraphic(fontAtlasText) {
        var _this = _super.call(this) || this;
        _this._fontAtlasText = null;
        _this._mesh = null;
        _this._dirty = true;
        _this._graphicType = GRAPHIC_TYPE.WORD;
        _this._graphicCount = 0;
        _this._padding = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
        };
        _this._color = [0.0, 1.0, 0.0, 1.0];
        _this._fontAtlasText = fontAtlasText;
        _this._deformerStack = new DeformerStack(_this, { uvs: false });
        // @ts-ignore
        _this._deformerStack.on('deformerAdded', function () {
            VERBOSE && console.log('deformer added');
            _this._buildShader();
        });
        // when do we need this? what exactly is changed? uniforms should just sync up. Maybe when we need to
        // re-calculate attributes?
        // @ts-ignore
        _this._deformerStack.on('deformerChanged', function () {
            VERBOSE && console.log('deformer changed');
            _this._buildShader();
        });
        return _this;
    }
    Object.defineProperty(FontAtlasTextGraphic.prototype, "deform", {
        get: function () {
            return this._deformerStack;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasTextGraphic.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value) {
            this._color = value;
            this._setUniform('uColor', value);
        },
        enumerable: false,
        configurable: true
    });
    FontAtlasTextGraphic.prototype._setUniform = function (property, value) {
        if (!this._mesh) {
            return;
        }
        this._mesh.shader.uniforms[property] = value;
    };
    Object.defineProperty(FontAtlasTextGraphic.prototype, "graphicType", {
        get: function () {
            return this._graphicType;
        },
        set: function (value) {
            this._graphicType = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasTextGraphic.prototype, "graphicCount", {
        get: function () {
            return this._graphicCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontAtlasTextGraphic.prototype, "padding", {
        get: function () {
            return this._padding;
        },
        enumerable: false,
        configurable: true
    });
    FontAtlasTextGraphic.prototype._buildGeometry = function () {
        var _a, _b, _c;
        var vertices, indices, uvs, weights = [];
        var count;
        switch (this._graphicType) {
            case GRAPHIC_TYPE.BOUNDS:
                (_a = this._buildBoundsGraphics(), vertices = _a.vertices, indices = _a.indices, uvs = _a.uvs, weights = _a.weights, count = _a.count);
                break;
            case GRAPHIC_TYPE.LINE:
                (_b = this._buildLineGraphics(), vertices = _b.vertices, indices = _b.indices, uvs = _b.uvs, weights = _b.weights, count = _b.count);
                break;
            case GRAPHIC_TYPE.WORD:
                (_c = this._buildWordGraphics(), vertices = _c.vertices, indices = _c.indices, uvs = _c.uvs, weights = _c.weights, count = _c.count);
                break;
            default: console.log('unknown');
        }
        var geometry = new PIXI.Geometry();
        geometry.addAttribute('aVertexPosition', vertices, 2);
        geometry.addAttribute('aUvs', uvs, 2);
        geometry.addAttribute('aWeight', weights, 1);
        geometry.addIndex(indices);
        this._geometry = geometry;
        this._graphicCount = count;
        this._weights = weights; // for debugging
    };
    FontAtlasTextGraphic.prototype._buildBoundsGraphics = function () {
        var bounds = this._fontAtlasText.getBounds();
        var x0 = bounds.x - this.padding.left;
        var x1 = bounds.x + bounds.width + this.padding.right;
        var y0 = bounds.y - this.padding.top;
        var y1 = bounds.y + bounds.height + this.padding.bottom;
        var _a = this._buildRectangle(x0, x1, y0, y1, 0, 0), vertices = _a.vertices, indices = _a.indices, uvs = _a.uvs, weights = _a.weights;
        return {
            vertices: vertices,
            indices: indices,
            uvs: uvs,
            weights: weights,
            count: 1
        };
    };
    FontAtlasTextGraphic.prototype._buildLineGraphics = function () {
        var selection = [];
        for (var i = 0; i < this._fontAtlasText.lines.length; i++) {
            var _a = this._fontAtlasText._getLineGlyphRange(i), start = _a[0], end = _a[1];
            selection.push([start, end]);
        }
        return this._buildSelection(selection);
    };
    FontAtlasTextGraphic.prototype._buildWordGraphics = function () {
        var selection = this._fontAtlasText.words;
        return this._buildSelection(selection);
    };
    /**
     *
     * @param x0
     * @param x1
     * @param y0
     * @param y1
     * @param indexOffset: vertex count offset
     * @param weightOffset: rectangle index
     */
    FontAtlasTextGraphic.prototype._buildRectangle = function (x0, x1, y0, y1, indexOffset, weightOffset) {
        if (indexOffset === void 0) { indexOffset = 0; }
        if (weightOffset === void 0) { weightOffset = 0; }
        var vertices = [
            x1, y1,
            x1, y0,
            x0, y0,
            x0, y1,
        ];
        var indices = [
            0 + indexOffset,
            1 + indexOffset,
            2 + indexOffset,
            2 + indexOffset,
            3 + indexOffset,
            0 + indexOffset
        ];
        var uvs = [
            1, 1,
            1, 0,
            0, 0,
            0, 1,
        ];
        var weights = [
            weightOffset,
            weightOffset,
            weightOffset,
            weightOffset
        ];
        return {
            vertices: vertices,
            indices: indices,
            uvs: uvs,
            weights: weights
        };
    };
    FontAtlasTextGraphic.prototype._buildSelection = function (selection) {
        var wordHeight = this._fontAtlasText.atlas.fontSize * this._fontAtlasText._fontFactor;
        var lineHeight = wordHeight * this._fontAtlasText._lineHeight;
        var allVertices = [];
        var allIndices = [];
        var allUvs = [];
        var allWeights = [];
        var count = 0;
        var wordIndex = 0;
        for (var _i = 0, selection_1 = selection; _i < selection_1.length; _i++) {
            var word = selection_1[_i];
            var glyphStartIndex = word[0];
            var glyphEndIndex = word[word.length - 1];
            var startVertexArray = this._fontAtlasText.getGlyphVertexArray(glyphStartIndex);
            var endVertexArray = this._fontAtlasText.getGlyphVertexArray(glyphEndIndex);
            var x0 = startVertexArray[4] - this.padding.left;
            var x1 = endVertexArray[0] + this.padding.right;
            var line = Math.ceil(startVertexArray[1] / lineHeight) - 1;
            var y0 = (line * lineHeight) - this.padding.top;
            var y1 = (y0 + wordHeight) + this.padding.bottom;
            var _a = this._buildRectangle(x0, x1, y0, y1, wordIndex * 4, wordIndex), vertices = _a.vertices, indices = _a.indices, uvs = _a.uvs, weights = _a.weights;
            allVertices.push(vertices);
            allIndices.push(indices);
            allUvs.push(uvs);
            allWeights.push(weights);
            wordIndex++;
            count++;
        }
        return {
            vertices: allVertices.flat(),
            indices: allIndices.flat(),
            uvs: allUvs.flat(),
            weights: allWeights.flat(),
            count: count
        };
    };
    FontAtlasTextGraphic.prototype._deleteGeometry = function () {
        if (!this._geometry) {
            return;
        }
        this._geometry.destroy();
        this._geometry = null;
    };
    FontAtlasTextGraphic.prototype._buildShader = function () {
        VERBOSE && console.log('_buildShader');
        // build shader
        // TODO: make into a property
        //  is this the same as tint?
        // const color = [1.0, 0.0, 0.0, 1.0];
        var uniforms = Object.assign({
            uColor: this.color,
            translationMatrix: this.transform.worldTransform.toArray(true)
        }, this.deform._combineUniforms());
        var vertexShader = this.deform._buildVertexShader();
        var fragmentShader = this.deform._buildFragmentShader();
        var shader = PIXI.Shader.from(vertexShader, fragmentShader, uniforms);
        this._shader = shader;
    };
    FontAtlasTextGraphic.prototype._build = function () {
        if (!this._dirty) {
            return;
        }
        this._deleteGeometry();
        this._buildGeometry();
        this._buildShader();
        this._dirty = false;
    };
    FontAtlasTextGraphic.prototype._render = function (renderer) {
        this._build();
        if (this.deform.dirty) {
            this.deform.update();
            this._buildShader();
        }
        this._renderDefault(renderer);
    };
    return FontAtlasTextGraphic;
}(MeshMixin(PIXI.Container)));
export { FontAtlasTextGraphic };
